// Constants for hosting package fetching
export const HOSTING_FETCH_LIMIT = 3;
export const HOSTING_MAX_FETCH_LIMIT = 1000;
export const TOTAL_HOSTING_COUNT_KEY = 'total_count';
export const HOSTING_LIST_PAGE_SS_KEY = 'hosting_list_page';
export const WORDPRESS_PURCHASE_METADATA_KEY = 'wordpress_purchase_metadata';

export const AI_PRODUCT_ROUTE_PREFIXES = ['/ai-sites', '/ai-store'] as const;

export const AI_PRODUCT_AM_REDIRECT_URLS: Record<
  (typeof AI_PRODUCT_ROUTE_PREFIXES)[number],
  string
> = {
  '/ai-sites': '/my-account/ai-sites',
  '/ai-store': '/my-account/ai-store',
};

// Constants for provisioning status detection
export const PROVISIONING_STATUSES = [
  'create',
  'pending_create',
  'provisioning',
  'renew',
  'pending_renew',
  'pending_reprovision',
  'reset',
  'pending_reset',
];
